import actionTypes from '../actionTypes';

export function showNotification( { message, appearance } ) {
  return {
    type: actionTypes.SHOW_NOTIFICATION,
    message,
    appearance
  }
}

export function resetNotification() {
  return {
    type: actionTypes.RESET_NOTIFICATION
  }
}
